module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "classifieds"
    }
  }, [_c('div', {
    staticClass: "button-container"
  }, [(_vm.isLoggedIn) ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/Classifieds/New"
    }
  }, [_vm._v("Submit a Classifieds Post")]) : _vm._e()], 1), _vm._v(" "), _c('section', {
    class: {
      'filter-controls': true, 'disabled': _vm.isFetching
    }
  }, [_c('div', {
    staticClass: "filter-control"
  }, [_c('div', {
    staticClass: "filter-group"
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('ul', _vm._l((_vm.postTypes), function(role, index) {
    return _c('li', {
      class: [{
        selected: index === _vm.selectedPostTypeId
      }],
      on: {
        "click": function($event) {
          _vm.setPostTypeId(index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(role) + "\n                    ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "filter-group"
  }, [_c('label', [_vm._v("Roles")]), _vm._v(" "), _c('ul', _vm._l((_vm.roles), function(role, index) {
    return _c('li', {
      class: [{
        selected: index === _vm.selectedRoleId
      }],
      on: {
        "click": function($event) {
          _vm.setRoleId(index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(role) + "\n                    ")])
  }))]), _vm._v(" "), (_vm.skillFilterId === 0) ? [_c('div', {
    staticClass: "filter-group"
  }, [_c('label', [_vm._v("Skill")]), _vm._v(" "), _c('div', {
    staticClass: "skill-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.skillSearchText),
      expression: "skillSearchText"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.isFetching
    },
    domProps: {
      "value": (_vm.skillSearchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.skillSearchText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.skillSearchText.length > 0) ? _c('button', {
    staticClass: "button"
  }, [_vm._v("X")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "filter-group"
  }, [(_vm.matchingSkills.length === 0) ? _c('span', [_vm._v("\n                    No matching tags... Search by skill name, or type a category\n                    to see all entries. Categories: Art, Software, Development, Engine, Writing, Production, Testing\n                ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "skills"
  }, _vm._l((_vm.matchingSkills), function(skill) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.setSkillId(skill.id)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(skill.skill) + "\n                        ")])
  }))])] : _vm._e(), _vm._v(" "), (_vm.skillFilterId > 0) ? [_c('div', {
    staticClass: "filter-group"
  }, [_c('label', [_vm._v("Skill")]), _vm._v(" "), _c('ul', {
    staticClass: "skills"
  }, [_c('li', {
    staticClass: "selected",
    on: {
      "click": function($event) {
        _vm.setSkillId(0)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-minus-circle"
  }), _vm._v(_vm._s(_vm.getSkill(_vm.skillFilterId)) + "\n                        ")])])])] : _vm._e()], 2)]), _vm._v(" "), (_vm.isFetching) ? _c('section', {
    staticClass: "loader"
  }, [_c('loader-large')], 1) : _vm._e(), _vm._v(" "), (!_vm.isFetching && _vm.posts.length === 0) ? _c('section', {
    staticClass: "no-posts"
  }, [_c('div', {
    staticClass: "validation-messages friendly"
  }, [_vm._v("\n            No matching results!\n            "), (_vm.selectedPostTypeId === 0) ? [_vm._v("Skill tags are still new for Game Projects. Try removing the\n                Skill filter.\n            ")] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (!_vm.isFetching && _vm.posts.length > 0) ? _c('section', {
    staticClass: "classifieds-posts"
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', {
      staticClass: "classifieds-post"
    }, [_c('header', [_c('div', {
      staticClass: "avatar-container"
    }, [_c('avatar', {
      attrs: {
        "profile-data": post.posterDetails,
        "profile-type": post.posterType,
        "size": "large",
        "show-xp-info": true
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "text-container"
    }, [(post.posterType === 'developer') ? _c('h1', {
      staticClass: "title"
    }, [_c('i', {
      staticClass: "fas fa-user fa-fw"
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (post.posterDetails.stringUrl)),
        "data-router-link": "true"
      }
    }, [_vm._v("\n                            " + _vm._s(post.posterDetails.alias) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (post.posterType === 'game') ? _c('h1', {
      staticClass: "title"
    }, [_c('i', {
      staticClass: "fas fa-gamepad fa-fw"
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/Game/" + (post.posterDetails.stringUrl)),
        "data-router-link": "true"
      }
    }, [_vm._v("\n                            " + _vm._s(post.posterDetails.alias) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(post.title))])]), _vm._v(" "), _c('div', {
      staticClass: "post-date"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateWithoutTimeRelative")(post.postDate)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDateWithJustTime")(post.postDate)))])])]), _vm._v(" "), _c('div', {
      staticClass: "sub-header"
    }, [(post.posterType === 'game') ? _c('span', [_vm._v("Recruiting")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "role-list"
    }, [(post.roleDesigner) ? _c('router-link', {
      staticClass: "role-tag",
      attrs: {
        "to": '/Browse/Developers?seekingRole=designers'
      }
    }, [(post.posterType === 'game') ? [_vm._v("Designers")] : [_vm._v("Designer")]], 2) : _vm._e(), _vm._v(" "), (post.roleArtist) ? _c('router-link', {
      staticClass: "role-tag",
      attrs: {
        "to": '/Browse/Developers?seekingRole=artists'
      }
    }, [(post.posterType === 'game') ? [_vm._v("Artists")] : [_vm._v("Artist")]], 2) : _vm._e(), _vm._v(" "), (post.roleProgrammer) ? _c('router-link', {
      staticClass: "role-tag",
      attrs: {
        "to": '/Browse/Developers?seekingRole=programmers'
      }
    }, [(post.posterType === 'game') ? [_vm._v("Programmers")] : [_vm._v("Programmer")]], 2) : _vm._e(), _vm._v(" "), (post.roleWriter) ? _c('router-link', {
      staticClass: "role-tag",
      attrs: {
        "to": '/Browse/Developers?seekingRole=writers'
      }
    }, [(post.posterType === 'game') ? [_vm._v("Writers")] : [_vm._v("Writer")]], 2) : _vm._e(), _vm._v(" "), (post.roleMusician) ? _c('router-link', {
      staticClass: "role-tag",
      attrs: {
        "to": '/Browse/Developers?seekingRole=musicians'
      }
    }, [(post.posterType === 'game') ? [_vm._v("Musicians")] : [_vm._v("Musician")]], 2) : _vm._e(), _vm._v(" "), (post.roleSfxArtist) ? _c('router-link', {
      staticClass: "role-tag",
      attrs: {
        "to": '/Browse/Developers?seekingRole=sfx'
      }
    }, [(post.posterType === 'game') ? [_vm._v("Sfx Artists")] : [_vm._v("Sfx Artist")]], 2) : _vm._e(), _vm._v(" "), (post.roleTester) ? _c('router-link', {
      staticClass: "role-tag",
      attrs: {
        "to": '/Browse/Developers?seekingRole=testers'
      }
    }, [(post.posterType === 'game') ? [_vm._v("Testers")] : [_vm._v("Tester")]], 2) : _vm._e(), _vm._v(" "), (post.roleProducer) ? _c('router-link', {
      staticClass: "role-tag",
      attrs: {
        "to": '/Browse/Developers?seekingRole=producers'
      }
    }, [(post.posterType === 'game') ? [_vm._v("Producers")] : [_vm._v("Producer")]], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "skill-list"
    }, _vm._l((post.skills), function(skillId) {
      return _c('router-link', {
        staticClass: "skill-tag",
        attrs: {
          "to": '/Browse/Developers?seekingSkill=' + skillId
        }
      }, [_vm._v("\n                        " + _vm._s(_vm.getSkill(skillId)) + "\n                    ")])
    }))]), _vm._v(" "), (!_vm.editMode) ? _c('markdown-content', {
      attrs: {
        "classes": "content",
        "content": post.pitch
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.canEdit(post)) ? _c('div', {
      staticClass: "contact-container"
    }, [_c('span', {
      on: {
        "click": function($event) {
          _vm.sendMail(post)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-envelope"
    }), _vm._v(" Mail")]), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          _vm.openConversation(post)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-comment-alt"
    }), _vm._v(" Chat")])]) : _vm._e(), _vm._v(" "), (_vm.canEdit(post)) ? _c('div', {
      staticClass: "edit-container"
    }, [(_vm.isLoggedIn) ? _c('router-link', {
      staticClass: "button",
      attrs: {
        "to": '/Classifieds/Edit/' + post.id
      }
    }, [_c('i', {
      staticClass: "fas fa-pencil-alt"
    }), _vm._v(" Edit\n                ")]) : _vm._e()], 1) : _vm._e()], 1)
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c919705c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/ClassifiedsFeed/Classifieds.vue
// module id = 915
// module chunks = 2